import { render, staticRenderFns } from "./TipoPedido.vue?vue&type=template&id=1a1b17c8&scoped=true"
import script from "./TipoPedido.vue?vue&type=script&lang=js"
export * from "./TipoPedido.vue?vue&type=script&lang=js"
import style0 from "./TipoPedido.vue?vue&type=style&index=0&id=1a1b17c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1b17c8",
  null
  
)

export default component.exports